import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";

const History = () => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div
              className="tab-pane fade show active"
              id="history"
              role="tabpanel"
              aria-labelledby="history-tab"
            >
              <div class="row mx-0">
                <div class="shadowclass mt-md-4 mt-3">
                  <div class="col-12">
                    <div class="counts">
                      <h4 class="event-alert"> History </h4>
                      <div class="row justify-content-between align-items-center mx-0">
                        <div class="col-md-6 col-12 px-0">
                          <div class="search-box mt-0 w-100">
                            <form
                              action="/productions"
                              id="MenuItemIndexForm"
                              method="get"
                              accept-charset="utf-8"
                            >
                              <input
                                name="keyword"
                                placeholder="Search"
                                type="text"
                                id="MenuItemKeyword"
                              />
                              <input type="submit" />
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="shadowclass mt-0 px-0">
                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th> Start </th>
                                <th class="header"> End </th>
                                <th class="header"> Field </th>
                                <th class="header"> Value </th>
                                <th class="header"> Replacement Value </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr></tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default History;
